import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { E as f, S as g } from "./icons.types-0722eef5.js";
function m({ title: r, titleId: n, size: i, width: o, height: s, extended: e = !1, ...d }) {
  const c = e ? f : g, t = i ? c[i] : o || c[e ? "s" : "l"], h = i ? c[i] : s || c[e ? "s" : "l"];
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: h,
      "aria-labelledby": n,
      ...d,
      children: [
        r ? /* @__PURE__ */ l("title", { id: n, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Hide_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m52.94 15.44-9.624 9.624C40.996 24.417 38.549 24 36 24c-10.696 0-19.846 6.918-23.632 10.248L14.96 36c2.526-2.133 6.96-5.409 12.328-7.359A10.447 10.447 0 0 0 25.5 34.5c0 2.358.794 4.52 2.11 6.27l-8.75 8.75 2.12 2.12 34.08-34.08-2.12-2.12ZM28.5 34.5c0-4.136 3.365-7.5 7.5-7.5 1.526 0 2.94.466 4.127 1.253L29.753 38.626A7.445 7.445 0 0 1 28.5 34.5Zm14.888-1.119.003.023c.055.36.11.721.11 1.096 0 4.136-3.365 7.5-7.5 7.5-.375 0-.737-.055-1.096-.109l-.024-.003-2.47 2.47c1.122.408 2.326.642 3.59.642 5.798 0 10.5-4.701 10.5-10.5 0-1.261-.245-2.46-.653-3.58l-2.46 2.461Zm3.74-3.741 2.269-2.268c4.572 2.236 8.191 5.075 10.237 6.873L57.038 36c-2.135-1.801-5.639-4.415-9.91-6.36Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Hide_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  m as Hide
};
